import * as React from 'react';
import { CustomDetailsRow } from './CustomDetailsRow';
import { IDetailsRowProps } from 'office-ui-fabric-react/lib/DetailsList';
import { KeyCodes } from 'office-ui-fabric-react/lib/Utilities';
import { NewFolderField } from '../NewFolderField';
import { observer } from 'mobx-react';

@observer
export class NewFolderRow extends React.Component<IDetailsRowProps, {}> {
    private newFolderField: NewFolderField = null;

    render() {
        return (
            <div onKeyDown={this.onKeyDown} onClick={this.focusOnTextField}>
                <CustomDetailsRow {...this.props}>
                    <NewFolderField ref={this.setNewFolderFieldRef} />
                </CustomDetailsRow>
            </div>
        );
    }

    private setNewFolderFieldRef = ref => (this.newFolderField = ref);

    private focusOnTextField = () => {
        if (this.newFolderField) {
            this.newFolderField.focus();
        }
    };

    private onKeyDown = (evt: React.KeyboardEvent<unknown>) => {
        switch (evt.which) {
            case KeyCodes.enter:
                // On enter focus on the text field
                this.focusOnTextField();
                break;
        }
    };
}
